import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import { connect } from 'react-redux';
//import { Prompt } from 'react-router-dom';
//import {errorValidataion,toggleSizeButton} from '../actions/sessions';
//import Toast from 'grommet/components/Toast';
import Article from 'grommet/components/Article';
import Heading from 'grommet/components/Heading';
import RadioButton from 'grommet/components/RadioButton';
import CheckBox from 'grommet/components/CheckBox';
import FormField from 'grommet/components/FormField';
import ReactTooltip from 'react-tooltip';
import TextInput from 'grommet/components/TextInput';
import Paragraph from 'grommet/components/Paragraph';
import Select from 'grommet/components/Select';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
import CircleInformationIcon from 'grommet/components/icons/base/CircleInformation';
import { toggleSizeButton, errorValidataion } from '../../State/actions/sessions';
import * as Constants from '../Redux/action_types/EPAConstants';
//import { fetchDefaults } from '../Redux/actions/epaActions';
import Warning from './Warning';
import { updateFinishButton, updateMasterandGatewayServices } from '../commonLogic';
let Hortondisply = 'none';
let Clouderadisply = 'none';
let MapRContentdisplay = 'none';
let HortonWorkEntValue = '';
let HortonWorkEntPlusValue = '';
let HortonWorkEntDataflowValue = '';
let ClouderaEssValue = '';
let ClouderaEntDataHubValue = '';
let ClouderaDataEngValue = '';
let ClouderaOpDbValue = '';
let ClouderaAnaDbValue = '';
let BluedataEpicsftwreValue = '';
let hpeEzmeralDataFabricLicense = '';
let BluedataMLsftwreValue = '';
let kubernetesCM = '';
let KubernetesHPECPValue = '';
let KubernetesDataAppsValue = '';
let KubernetesDataAppsUniversalValue = '';
let KubernetesDataAppswMLOpsValue = '';
let KubernetesDataAppsUniversalwMLOpsValue = '';
let HDFSSelected, ScalitySelected, WekaSelected, HiveSelected, CassandraSelected, ImpalaSelected, HBaseSelected;
let SparkStreamSelected, KafkaSelected, FlumeSelected, NifiSelected, YarnSelected, SparkSelected, TensorflowSelected, PytorchSelected, MinifiSelected;
let CustomQtyVal, SingleQtyVal;
var Qtyvalue = '';
let overallConfigType = "";

class HadoopServices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            HortonWorksEnterpriseCheched: '',
            HortonWorksEnterprisePlusCheched: '',
            Radiobtn1: '', Radiobtn2: '',
            ClouderaDataScienceEngineeringCheched: '',
            ClouderaOperationalDBCheched: '',
            ClouderaEssentialsCheched: '',
            ClouderaDataWarehouseCheched: '',
            ClouderaEnterpriseDataHubCheched: '',
            BlueDataCheched: '',
            HPCMOptions: [],
            HWSupportOptions: [],
            MapROPtions: [],
            ScalityOptions: [],
            WekaOptions: [],
            iLOLicenseOptions: [],
            HadoopLicenseOptions: [],
            LinuxLicenseOptions: [],
            HortonRadioBtn2: '',
            HortonRadioBtn1: '',
            MapRRadioBtn: '',
            NoneRadioBtn: '',
            CloudEraRadioBtn1: '',
            HortonRadioBtn3: '',
            HortonChBox4: '',
            CloudEraChBox4: '',
            CloudEraChBox5: '',
            CloudEraChBox6: '',
            CloudEraChBox3: '',
            CloudEraChBox2: '',
            MapRXDChkBox: '',
            MapRAnalyticsChkBox: '',
            MapRAnalyticswithSparkChkBox: '',
            MapRStreamsChkBox: '',
            MapRDatabaseChkBox: '',
            MapRBundleChkBox: '',
            DataFabricServiceChkBox: '',
            AppStoreCheckbox: '',
            SingleImageCheckbox: '',
            EPICCustomCheckbox: '',
            DeploymentCheckbox: '',
            InstallationCheckbox: '',
            BlueDataEpicChecked: false,
            BlueDataMLChecked: false,
            KubernetesHPECPChBox: false,
            KubernetesDataappsChBox: false,
            KubernetesDataappsUniversalChBox: false,
            KubernetesDataappswMLOpsChBox: false,
            KubernetesDataappsUniversalwMLOpsChBox: false,


        };
        this.onHortonRadioBtnChange = this.onHortonRadioBtnChange.bind(this);
        this.onHortoninsideRadioBtnChange = this.onHortoninsideRadioBtnChange.bind(this);
        this.onBlueDataRadioBtnChange = this.onBlueDataRadioBtnChange.bind(this);

    }

    onKubernetesChBoxsChange = (ChBox) => {
        switch (ChBox) {
            case "HPECP":
                this.state.KubernetesHPECPChBox = this.state.KubernetesHPECPChBox ? false : true;
                break;
            case "Data Apps":
                if (ChBox.isChecked || this.state.KubernetesDataappswMLOpsChBox) {
                    this.state.KubernetesDataappsChBox = this.state.KubernetesDataappsChBox ? false : true;
                }
                break;
            case "Data Apps Universal":
                this.state.KubernetesDataappsUniversalChBox = this.state.KubernetesDataappsUniversalChBox ? false : true;
                break;
            case "Data Apps w/ML Ops":
                if (ChBox.isChecked || this.state.KubernetesDataappsChBox)
                    this.state.KubernetesDataappswMLOpsChBox = this.state.KubernetesDataappswMLOpsChBox ? false : true;
                break;
            case "Data Apps Universal w/ML Ops":
                this.state.KubernetesDataappsUniversalwMLOpsChBox = this.state.KubernetesDataappsUniversalwMLOpsChBox ? false : true;
                break;
        }
        this.updateKubernetesChkboxtoWorkload(ChBox)
    }

    updateKubernetesChkboxtoWorkload = (ChBox) => {
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter((Services) => {
            if (Services['@Type'] === "Data Apps" && Services['@Type'] === ChBox) {
                Services['@IsSelected'] = this.state.KubernetesDataappsChBox.toString();
                //Services['@Description'] = this.state.KubernetesDataappsChBox ? "9x5 1y" : "None";
                Services['@Description'] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(item => item['@Type'] === 'Data Apps').Item;
            }
            if (Services['@Type'] === "Data Apps Universal" && Services['@Type'] === ChBox) {
                Services['@IsSelected'] = this.state.KubernetesDataappsUniversalChBox.toString();
            }
            if (Services['@Type'] === "Data Apps w/ML Ops") {
                Services['@IsSelected'] = this.state.KubernetesDataappswMLOpsChBox.toString();
                // Services['@Description'] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(item => item['@Type'] === 'Data Apps w/ML Ops').Item.filter(option => option !== 'None')[0];
                Services['@Description'] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(item => item['@Type'] === 'Data Apps w/ML Ops').Item;
            }
            if (Services['@Type'] === "Data Apps Universal w/ML Ops" && Services['@Type'] === ChBox) {
                Services['@IsSelected'] = this.state.KubernetesDataappsUniversalwMLOpsChBox.toString();
            }
        })
        this.setState({})
    }
    onKubernetesvalueChanges = (e, serviceName) => {
        let value = e.option.toString()
        switch (serviceName) {
            case 'HPECP':
                KubernetesHPECPValue = value;
                //this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[2]['@Description'] = KubernetesHPECPValue
                break;
            case 'Data Apps':
                KubernetesDataAppsValue = value;
                //this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[3]['@Description'] = KubernetesDataAppsValue
                break;
            case 'Data Apps Universal':
                KubernetesDataAppsUniversalValue = value;
                //this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[4]['@Description'] = KubernetesDataAppsUniversalValue
                break;
            case 'Data Apps w/ML Ops':
                KubernetesDataAppswMLOpsValue = value;
                //this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[5]['@Description'] = KubernetesDataAppswMLOpsValue
                break;
            case 'Data Apps Universal w/ML Ops':
                KubernetesDataAppsUniversalwMLOpsValue = value;
                //this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[6]['@Description'] = KubernetesDataAppsUniversalwMLOpsValue
                break;

        }
        this.updateKubernetesvaluestoWorkload(serviceName, value)
    }

    updateKubernetesvaluestoWorkload = (serviceName, value) => {
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter((Services) => {
            if (Services['@Type'] === serviceName) {
                Services['@Description'] = value
            }
        })
        this.setState({});
    }
    onCheckboxChange(e, val) {
        switch (val) {
            case 'HortonWorks Enterprise':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEnt"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEnt"] = "false"
                } else {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEnt"] = "true"
                }
                break;
            case 'HortonWorks Enterprise Plus':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEntPlus"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEntPlus"] = "false"
                } else {
                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEntPlus"] = "true"
                }
                break;
            case 'Cloudera Data Science & Engineering':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDSE"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDSE"] = "false"
                } else {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDSE"] = "true"
                }
                break;
            case 'Cloudera Operational DB':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaODB"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaODB"] = "false"
                } else {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaODB"] = "true"
                }
                break;
            case 'Cloudera Essentials':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEss"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEss"] = "false"
                } else {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEss"] = "true"
                }
                break;
            case 'Cloudera Data Warehouse':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDW"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDW"] = "false"
                } else {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDW"] = "true"
                }
                break;
            case 'Cloudera Enterprise Data Hub':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEntDH"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEntDH"] = "false"
                } else {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEntDH"] = "true"
                }
                break;
            case 'BlueData':
                if (this.props.workload.UserInputs.Environments.HadoopServices.Services["@BlueData"] === "true") {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@BlueData"] = "false"
                } else {

                    this.props.workload.UserInputs.Environments.HadoopServices.Services["@BlueData"] = "true"
                }
                break;
            default: break;

        }
        this.setState({})
    }
    componentWillMount() {
        if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses) {
                if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR) {
                    if (Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License)) {
                        let bothUnselected = true;
                        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.findIndex(license => license["@Type"] === Constants.DATA_APPS) > -1) {
                            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(license => license["@Type"] === Constants.DATA_APPS)["@IsSelected"] === Constants.tRUE_) {
                                bothUnselected = false;
                            }
                        }
                        if (bothUnselected) {
                            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.findIndex(license => license["@Type"] === Constants.DATA_APPS_wMLOPs) > -1) {
                                if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(license => license["@Type"] === Constants.DATA_APPS_wMLOPs)["@IsSelected"] === Constants.tRUE_) {
                                    bothUnselected = false;
                                }
                            }
                        }
                        if (bothUnselected) {
                            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.findIndex(license => license["@Type"] === Constants.DATA_APPS) > -1) {
                                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(license => license["@Type"] === Constants.DATA_APPS)["@IsSelected"] = Constants.tRUE_;
                                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(license => license["@Type"] === Constants.DATA_APPS)["@Description"] = Constants.NINE_X_FIVE;
                            }
                        }
                    }
                }
            }
        }
    }
    OnLicenseChange(e, service) {
        switch (service) {

            case "MapR":
                this.props.workload.UserInputs.Environments.HadoopServices['MapR'] = e.value;
                break;
            case "Scality":
                this.props.workload.UserInputs.Environments.HadoopServices['Scality'] = e.value;
                break;
            case "Weka":
                this.props.workload.UserInputs.Environments.HadoopServices['Weka'] = e.value;
                break;
            case "HPCM":
                this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] = e.value;
                break;
            case "HWSupport":
                this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'] = e.value;
                break;
            case "LinuxLicense":
                this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'] = e.value;
                break;
            case "HadoopLicense":
                this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense'] = e.value;
                break;
            case "iLoLicense":
                this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'] = e.value;
                break;
            case Constants.VMWARE_VCENTER:
                this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vCenter"] = e.value;
                break;
            case Constants.VMWARE_VSPHERE:
                this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vSphere"] = e.value;
                break;
            case Constants.VMWARE_VREALIZE:
                this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vRealize"] = e.value;
                break;
            case Constants.VMWARE_VSAN:
                this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vSAN"] = e.value;
                break;
            default: break;
        }
        this.setState({})
    }
    componentDidMount() {
        if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {

            if (this.props.activeSession.isSizeEnabled)
                this.props.OnToggleSizeButton(false);

        }


        if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
            this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                if (val['@Type'] === "Storage") {
                    val.Service.filter((servicename) => {
                        switch (servicename['@Type']) {
                            case Constants.DATA_LAKE:
                                HDFSSelected = (/true/i).test((/true/i).test(servicename['@Selected']))
                                break;

                            case "Scality":
                                ScalitySelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "Weka":
                                WekaSelected = (/true/i).test(servicename['@Selected'])
                                break;
                        }
                    })

                }
                if (val['@Type'] === "Database") {
                    val.Service.filter((servicename) => {
                        switch (servicename['@Type']) {
                            case "Hive":
                                HiveSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "Cassandra":
                                CassandraSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "Impala":
                                ImpalaSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "HBase":
                                HBaseSelected = (/true/i).test(servicename['@Selected'])
                                break;

                        }
                    })
                }

                if (val['@Type'] === "Streaming") {
                    val.Service.filter((servicename) => {
                        switch (servicename['@Type']) {
                            case "Spark Streaming":
                                SparkStreamSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "Kafka":
                                KafkaSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "Flume":
                                FlumeSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "Nifi":
                                NifiSelected = (/true/i).test(servicename['@Selected'])
                                break;
                        }

                    })
                }

                if (val['@Type'] === "Analytics") {
                    val.Service.filter((servicename) => {
                        switch (servicename['@Type']) {
                            case "Yarn":
                                YarnSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "Spark":
                                SparkSelected = (/true/i).test(servicename['@Selected'])
                                break;
                        }

                    })
                }

                if (val['@Type'] === "AI") {
                    val.Service.filter((servicename) => {
                        switch (servicename['@Type']) {
                            case "Tensorflow":
                                TensorflowSelected = (/true/i).test(servicename['@Selected'])
                                break;

                            case "PyTorch":
                                PytorchSelected = (/true/i).test(servicename['@Selected'])
                                break;
                        }

                    })
                }
                if (val['@Type'] === "IoT") {
                    switch (val.Service['@Type']) {
                        case "MiNifi":
                            MinifiSelected = (/true/i).test(val.Service['@Selected'])
                            break;
                    }
                }
            })
        }

        if (updateFinishButton(this.props.workload, this.props.displayWarning, this.props.activeSession.isSizeEnabled)) {
            this.props.OnToggleSizeButton(true);
        }
        this.setState({})
    }

    onHortonChBoxChange(e, name) {
        if (this.state.HortonChBox4 === true) {
            this.state.HortonChBox4 = false
        } else {
            this.state.HortonChBox4 = true
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(Servicename => Servicename['@Type'] === Constants.HORTONWORKS_DATAFLOW)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.HORTONWORKS_DATAFLOW).Item[0];
        }
        this.oncheckboxupdateWorkload(this.state.HortonChBox4, name)

    }
    onClouderaESSChBoxChange(e, name) {
        if (this.state.CloudEraChBox2 === true) {
            this.state.CloudEraChBox2 = false
        } else {
            this.state.CloudEraChBox2 = true
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(Servicename => Servicename['@Type'] === Constants.CLOUDERA_ESSENTIALS)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.CLOUDERA_ESSENTIALS).Item[0];
        }
        this.oncheckboxupdateWorkload(this.state.CloudEraChBox2, name)

    }
    onClouderaEntDataHubChBoxChange(e, name) {
        if (this.state.CloudEraChBox3 === true) {
            this.state.CloudEraChBox3 = false
        } else {
            this.state.CloudEraChBox3 = true
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(Servicename => Servicename['@Type'] === Constants.CLOUDERA_ENT_DATAHUB)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.CLOUDERA_ENT_DATAHUB).Item[0];
        }
        this.oncheckboxupdateWorkload(this.state.CloudEraChBox3, name)

    }

    onClouderaDataEngChBoxChange(e, name) {
        if (this.state.CloudEraChBox4 === true) {
            this.state.CloudEraChBox4 = false
        } else {
            this.state.CloudEraChBox4 = true
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(Servicename => Servicename['@Type'] === Constants.CLOUDERA_DATA_ENGINEERING)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.CLOUDERA_DATA_ENGINEERING).Item[0];
        }
        this.oncheckboxupdateWorkload(this.state.CloudEraChBox4, name)

    }
    onClouderaOpDBChBoxChange(e, name) {
        if (this.state.CloudEraChBox5 === true) {
            this.state.CloudEraChBox5 = false
        } else {
            this.state.CloudEraChBox5 = true
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(Servicename => Servicename['@Type'] === Constants.CLOUDERA_OP_DATABASE)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.CLOUDERA_OP_DATABASE).Item[0];
        }
        this.oncheckboxupdateWorkload(this.state.CloudEraChBox5, name)

    }
    onClouderaAnaDBChBoxChange(e, name) {
        if (this.state.CloudEraChBox6 === true) {
            this.state.CloudEraChBox6 = false
        } else {
            this.state.CloudEraChBox6 = true
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(Servicename => Servicename['@Type'] === Constants.CLOUDERA_ANALYTICAL_DB)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.CLOUDERA_ANALYTICAL_DB).Item[0];
        }
        this.oncheckboxupdateWorkload(this.state.CloudEraChBox6, name)

    }
    OnBlueDataChange(e, name) {
        if (name === "BlueData EPIC Software") {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@Description'] = e.value.toString();
        } else if (name === Constants.HPE_EZMERAL_MLOPS) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@Description'] = e.value.toString();
        } else if (name === Constants.HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === "Kubernetes CM")['@Description'] = e.value.toString();
            if (e.value === Constants.NONE_) {
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license[Constants.ATTRIBUTE_TYPE] === Constants.KUBERNETES_CM)[Constants.ATTRIBUTE_ISSELECTED] = Constants.fALSE_;
            } else {
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license[Constants.ATTRIBUTE_TYPE] === Constants.KUBERNETES_CM)[Constants.ATTRIBUTE_ISSELECTED] = Constants.tRUE_;
            }
        } else if (name === Constants.HPE_EZMERAL_DF_XD) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_EZMERAL_DF_XD)['@Description'] = e.value.toString();
        }
        this.setState({})
    }

    oncheckboxupdateWorkload(value, name) {
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
            switch (Servicename['@Type']) {
                case "Cloudera Data Engineering":
                    if (name === 'ClouderaDataEngValue')
                        Servicename['@IsSelected'] = value.toString();

                    break;

                case "Cloudera Operational Database":
                    if (name === 'ClouderaOpDbValue')
                        Servicename['@IsSelected'] = value.toString();

                    break;

                case "Cloudera Analytical Database":
                    if (name === 'ClouderaAnaDbValue')
                        Servicename['@IsSelected'] = value.toString();

                    break;

                case "Cloudera Enterprise Data Hub":
                    if (name === 'ClouderaEntDataHubValue')
                        Servicename['@IsSelected'] = value.toString();

                    break;

                case "Cloudera Essentials":
                    if (name === 'ClouderaEssValue')
                        Servicename['@IsSelected'] = value.toString();

                    break;

                case "BlueData":
                    if (name === 'BlueDataValue')
                        Servicename['@IsSelected'] = value.toString();

                    break;

            }
        })
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter((Servicename) => {
            switch (Servicename['@Type']) {

                case "Hortonworks DataFlow":
                    if (name === 'HortonWorkEntDataflowValue')
                        Servicename['@IsSelected'] = value.toString();

                    break;
            }
        })
        this.setState({})
    }

    onMapRcheckBoxChange(e, name) {
        switch (e.target.attributes["id"].value) {
            case "XD":
                if (this.state.MapRXDChkBox && (this.state.MapRAnalyticsChkBox || this.state.MapRAnalyticswithSparkChkBox || this.state.MapRStreamsChkBox || this.state.MapRDatabaseChkBox)) {
                    break;
                }
                this.state.MapRXDChkBox = this.state.MapRXDChkBox ? false : true;
                break;
            case "Analytics":
                this.state.MapRAnalyticsChkBox = this.state.MapRAnalyticsChkBox ? false : true;
                this.state.MapRXDChkBox = this.state.MapRAnalyticsChkBox ? true : this.state.MapRXDChkBox
                break;
            case "Spark":
                this.state.MapRAnalyticswithSparkChkBox = this.state.MapRAnalyticswithSparkChkBox ? false : true;
                this.state.MapRXDChkBox = this.state.MapRAnalyticswithSparkChkBox ? true : this.state.MapRXDChkBox
                break;
            case "Streams":
                this.state.MapRStreamsChkBox = this.state.MapRStreamsChkBox ? false : true;
                this.state.MapRXDChkBox = this.state.MapRStreamsChkBox ? true : this.state.MapRXDChkBox
                break;
            case "Database":
                this.state.MapRDatabaseChkBox = this.state.MapRDatabaseChkBox ? false : true;
                this.state.MapRXDChkBox = this.state.MapRDatabaseChkBox ? true : this.state.MapRXDChkBox
                break;
            case "Bundle":
                this.state.MapRBundleChkBox = this.state.MapRBundleChkBox ? false : true;
                break;
            case Constants.SERVICES_:
                this.state.DataFabricServiceChkBox = this.state.DataFabricServiceChkBox ? false : true;
                break;
        }
        this.onMapRcheckboxupdateWorkload(name)
    }
    onMapRcheckboxupdateWorkload(name) {
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.filter((Servicename) => {
            switch (Servicename['@Type']) {
                case Constants.DATAFABRIC_XD:
                    Servicename['@IsSelected'] = this.state.MapRXDChkBox.toString();
                    break;

                case Constants.DATAFABRIC_ANALYTICS:
                    if (name === Constants.DATAFABRIC_ANALYTICS)
                        Servicename['@IsSelected'] = this.state.MapRAnalyticsChkBox.toString();
                    break;

                case Constants.DATAFABRIC_SPARK:
                    if (name === Constants.DATAFABRIC_SPARK)
                        Servicename['@IsSelected'] = this.state.MapRAnalyticswithSparkChkBox.toString();
                    break;

                case Constants.DATAFABRIC_STREAMS:
                    if (name === Constants.DATAFABRIC_STREAMS)
                        Servicename['@IsSelected'] = this.state.MapRStreamsChkBox.toString();
                    break;

                case Constants.DATAFABRIC_DATABASE:
                    if (name === Constants.DATAFABRIC_DATABASE)
                        Servicename['@IsSelected'] = this.state.MapRDatabaseChkBox.toString();
                    break;

                case Constants.DATAFABRIC_BUNDLE:
                    if (name === Constants.DATAFABRIC_BUNDLE) {
                        Servicename['@IsSelected'] = this.state.MapRBundleChkBox.toString();
                        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.forEach(element => {
                            if (element["@Type"] === Constants.DATAFABRIC_XD) {
                                element['@IsSelected'] = "false";
                            }
                        });
                    } else if (name === Constants.DATAFABRIC_XD) {
                        Servicename['@IsSelected'] = "false";
                    }

                    break;

                case Constants.DATAFABRIC_SERVICES:
                    if (name === Constants.DATAFABRIC_SERVICES) {
                        Servicename['@IsSelected'] = this.state.DataFabricServiceChkBox.toString();
                    }

            }
        })
        this.setState({})
    }
    onHortonRadioBtnChange(e) {
        if (e.target.attributes["id"].value === "choice1-1") {
            this.state.HortonRadioBtn1 = true; this.state.CloudEraRadioBtn1 = false; this.state.MapRRadioBtn = false;
            this.state.NoneRadioBtn = false;
        } else if (e.target.attributes["id"].value === "choice1-2") {
            this.state.HortonRadioBtn1 = false; this.state.CloudEraRadioBtn1 = true; this.state.MapRRadioBtn = false;
            this.state.NoneRadioBtn = false;
        } else if (e.target.attributes["id"].value === "choice1-3") {
            this.state.HortonRadioBtn1 = false; this.state.CloudEraRadioBtn1 = false; this.state.MapRRadioBtn = true;
            this.state.NoneRadioBtn = false;
        } else if (e.target.attributes["id"].value === Constants.NONE_RADBTN_ID) {
            this.state.HortonRadioBtn1 = false; this.state.CloudEraRadioBtn1 = false; this.state.MapRRadioBtn = false;
            this.state.NoneRadioBtn = true;
        }
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] = this.state.CloudEraRadioBtn1.toString()
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected'] = this.state.HortonRadioBtn1.toString()
        if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected'] = this.state.MapRRadioBtn.toString();
            let dataLakeObject = this.props.workload.UserInputs.Environments.Functions.Function.find(tab => tab["@Type"] === Constants.STORAGE_).Service.find(service => service["@Type"] === Constants.DATA_LAKE);
            if (this.state.MapRRadioBtn) {
                if (parseInt(dataLakeObject.Hardware["@NodesCount"], 10) < parseInt(Constants.DATALAKE_MIN_NODES, 10)) {
                    this.props.workload.UserInputs.Environments.isDataLakeNodeCountUpdated = Constants.tRUE_;
                    this.props.workload.UserInputs.Environments.DataLakeNodeCount = dataLakeObject.Hardware["@NodesCount"];
                    this.props.workload.UserInputs.Environments.updateDataLakeRecommendations = Constants.tRUE_;
                    dataLakeObject.Hardware["@NodesCount"] = Constants.DATALAKE_MIN_NODES;
                }
            } else {
                if (this.props.workload.UserInputs.Environments.isDataLakeNodeCountUpdated === Constants.tRUE_) {
                    this.props.workload.UserInputs.Environments.isDataLakeNodeCountUpdated = Constants.fALSE_;
                    this.props.workload.UserInputs.Environments.updateDataLakeRecommendations = Constants.tRUE_;
                    dataLakeObject.Hardware["@NodesCount"] = this.props.workload.UserInputs.Environments.DataLakeNodeCount;
                }
            }
            updateMasterandGatewayServices(this.props.workload);
        }
        this.setState({});
    }
    onHortoninsideRadioBtnChange(e) {
        if (e.target.attributes["id"].value === "Ent") {
            this.state.HortonRadioBtn2 = true; this.state.HortonRadioBtn3 = false;
            if (this.state.HortonRadioBtn2) {
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(Servicename => Servicename['@Type'] === Constants.HORTONWORK_ENT)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.HORTONWORK_ENT).Item[0];
            }
        }
        else if (e.target.attributes["id"].value === "EntPlus") {
            this.state.HortonRadioBtn2 = false; this.state.HortonRadioBtn3 = true
            if (this.state.HortonRadioBtn3) {
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(Servicename => Servicename['@Type'] === Constants.HORTONWORK_ENT_PLUS)["@Description"] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(name => name["@Type"] === Constants.HORTONWORK_ENT_PLUS).Item[0]
            }
        } else {
        }
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter((Servicename) => {
            switch (Servicename['@Type']) {
                case "HortonWork Enterprise":
                    Servicename['@IsSelected'] = this.state.HortonRadioBtn2.toString();
                    break;

                case "HortonWork Enterprise Plus":
                    Servicename['@IsSelected'] = this.state.HortonRadioBtn3.toString();
                    break;

            }
        })
        this.setState({});
    }
    onBlueDataRadioBtnChange(e) {
        if (e.target.attributes["id"].value === "BlueEPIC") {
            this.state.BlueDataEpicChecked = true; this.state.BlueDataMLChecked = false

            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@Description'] = Constants.NINE_X_FIVE; //aditya
        }
        else if (e.target.attributes["id"].value === "BlueML") {
            this.state.BlueDataEpicChecked = false; this.state.BlueDataMLChecked = true
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@Description'] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(license => license['@Type'] === Constants.HPE_EZMERAL_MLOPS).Item[0];
        } else {
        }
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@IsSelected'] = this.state.BlueDataEpicChecked.toString();
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@IsSelected'] = this.state.BlueDataMLChecked.toString();
        this.setState({});
    }
    OnServicedrpdwnChange(e, Service) {
        let value = e.value;
        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
            switch (Servicename['@Type']) {
                case "Cloudera Data Engineering":
                    if (Service === 'ClouderaDataEngValue')
                        Servicename['@Description'] = value

                    break;

                case "Cloudera Operational Database":
                    if (Service === 'ClouderaOpDbValue')
                        Servicename['@Description'] = value

                    break;

                case "Cloudera Analytical Database":
                    if (Service === 'ClouderaAnaDbValue')
                        Servicename['@Description'] = value

                    break;

                case "Cloudera Enterprise Data Hub":
                    if (Service === 'ClouderaEntDataHubValue')
                        Servicename['@Description'] = value

                    break;

                case "Cloudera Essentials":
                    if (Service === 'ClouderaEssValue')
                        Servicename['@Description'] = value

                    break;

            }
        })

        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter((Servicename) => {
            switch (Servicename['@Type']) {
                case "HortonWork Enterprise":
                    if (Service === 'HortonWorkEntValue')
                        Servicename['@Description'] = value

                    break;

                case "HortonWork Enterprise Plus":
                    if (Service === 'HortonWorkEntPlusValue')
                        Servicename['@Description'] = value

                    break;

                case "Hortonworks DataFlow":
                    if (Service === 'HortonWorkEntDataflowValue')
                        Servicename['@Description'] = value

                    break;
            }
        })
        this.setState({})

    }

    onLicensesChanged(e, name) {

        if (name === "AppStore") {
            if (this.state.AppStoreCheckbox) {
                this.state.AppStoreCheckbox = false
            } else {
                this.state.AppStoreCheckbox = true
            }
            this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = this.state.AppStoreCheckbox.toString()
        } else if (name === "SingleImage") {
            if (this.state.SingleImageCheckbox) {
                this.state.SingleImageCheckbox = false
                // if(! this.state.EPICCustomCheckbox){
                //      this.state.DeploymentCheckbox = false
                // }
            } else {
                this.state.SingleImageCheckbox = true
                this.state.DeploymentCheckbox = true
            }
            this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text'] = this.state.SingleImageCheckbox.toString()
            this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] = this.state.DeploymentCheckbox.toString()

        } else if (name === "CustomImage") {
            if (this.state.EPICCustomCheckbox) {
                this.state.EPICCustomCheckbox = false
                //  if(! this.state.SingleImageCheckbox){
                //      this.state.DeploymentCheckbox = false
                // }
            } else {
                this.state.EPICCustomCheckbox = true
                this.state.DeploymentCheckbox = true
            }
            this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text'] = this.state.EPICCustomCheckbox.toString()
            this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] = this.state.DeploymentCheckbox.toString()

        } else if (name === "Deployment") {
            if (this.state.DeploymentCheckbox) {
                this.state.DeploymentCheckbox = false
            } else {
                this.state.DeploymentCheckbox = true
            }
            this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] = this.state.DeploymentCheckbox.toString()
        } else if (name === "Installation") {
            if (this.state.InstallationCheckbox) {
                this.state.InstallationCheckbox = false
            } else {
                this.state.InstallationCheckbox = true
            }
            this.props.workload.UserInputs.Environments.HadoopServices['Installation'] = this.state.InstallationCheckbox.toString()
        }

        this.setState({})
    }
    onLicensesQtyChanged(e, name, chblr) {
        var text = parseInt(e.target.value, 10);
        var number = /^[0-9]+$/

        if (chblr === "Change") {
            if (isNaN(text)) {
                Qtyvalue = " ";
            }
            else if ((number.test(text)) && (text <= 9999) && (text >= 1) || isNaN(text)) {
                Qtyvalue = text.toString();
            }
            else {

            }
        } else {
            if (isNaN(text)) {
                Qtyvalue = "1";
            }
            else {
                Qtyvalue = text.toString();
            }
        }
        if (name === "SingleImage") {
            this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty'] = Qtyvalue
        } else if (name === "CustomImage") {
            this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty'] = Qtyvalue
        }
        // this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.BlueDataEPICLicenses.License.filter((Servicename) => {
        //     switch (Servicename['@Type']) {
        //         case "SingleImage":
        //             if (name === Servicename['@Type']) {
        //                 Servicename['@Value'] = value
        //             }
        //             break;
        //         case "CustomImage":
        //             if (name === Servicename['@Type']) {
        //                 Servicename['@Value'] = value
        //             }
        //             break;
        //     }
        // })
        this.setState({})
    }

    calculateBlueDataCount = (role, BlueDataCount) => {
        if (role["@Type"] !== Constants.GATEWAY_ && parseInt(role["@NodesCount"], 10) > 0) {
            let ProcContrl = []
            let CoreContrl = []
            ProcContrl = role["@Proc"].split("/");
            CoreContrl = ProcContrl[2].split(" ")
            BlueDataCount += parseInt(role["@NodesCount"], 10) * role["@ProcQty"] * parseInt(CoreContrl[1], 10);
        }
        return BlueDataCount;
    }

    render() {
        let scalitydisplay = "none";
        let Wekadisplay = "none";
        let HortonWorkEntOptions = []
        let HortonWorkEntPlusOptions = []
        let HortonWorkEntDataflowOptions = []
        let ClouderaEssOptions = []
        let ClouderaEntDataHubOptions = []
        let ClouderaDataEngOptions = []
        let ClouderaOpDbOptions = []
        let ClouderaAnaDbOptions = []
        let BluedataEpicsftwreOptions = []
        let BluedataMLsftwreOptions = []
        let externalK8sClusterMngrOptions = [];
        let hpeEzmeralDataFabricLicenseOptions = [];
        let BlueDataMLDisabled = false
        let BlueDataEpicDisabled = false
        let KubernetesHPECPOptions = []
        let KubernetesDataAppsOptions = []
        let KubernetesDataAppsUniversalOptions = []
        let KubernetesDataAppswMLOpsOptions = []
        let KubernetesDataAppsUniversalwMLOpsOptions = []
        let VMWare_vCenter_Options = [];
        let VMWare_vSphere_Options = [];
        let VMWare_vRealize_Options = [];
        let VMWare_vSAN_Options = [];
        let VMWareLicenses = "";
        let VMWare_VSphereTooltip = 'VMWare vSphere licenses';
        let VMWare_VCenterTooltip = 'VMWare vCenter licenses';
        let datalakeServiceNote = '';

        if (this.props.workload !== undefined && this.props.workload !== null) {
            var HWEntDisabled = false
            var HwEntPlusDisabled = false
            var HwDataFlowDisabled = false
            var CLEraDataSciNdEngDisabled = false
            var CLEraOpDBDisabled = false
            var CLEraAnalyDBDisabled = false
            var CLEraEntDataHubDisabled = false
            var CLEraESSDisabled = false
            var ClouderaLicensesDisabled = false
            var HortonLicensesDisabled = false
            var MapRXDDisabled = true
            var MapRAnalyticsDisabled = true
            var MapRAnalyticswithSparkDisabled = true
            var MapRStreamsDisabled = true
            var MapRDatabaseDisabled = true
            var MapRBundleDisabled = true;
            let DataFabricServicesDisabled = true;
            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses === undefined) {
                var ServiceLicenses = {
                    Hortonworks: {
                        "@IsSelected": "false",
                        "License": [
                            {
                                "@IsSelected": "false",
                                "@Description": "HDE 24x7 1y"
                            },
                            {
                                "@IsSelected": "false",
                                "@Description": "HDP 24x7 1y"
                            },
                            {
                                "@IsSelected": "false",
                                "@Description": "HDF Ed 10 BO Nodes"
                            }
                        ]
                    },
                    "Cloudera": {
                        "@IsSelected": "false",
                        "License": [
                            {
                                "@IsSelected": "false",
                                "@Description": "CEDE 8x5 1yr"
                            },
                            {
                                "@IsSelected": "false",
                                "@Description": "CEOD 8x5 1yr"
                            },
                            {
                                "@IsSelected": "false",
                                "@Description": "CEAD 8x5 1yr"
                            },
                            {
                                "@IsSelected": "false",
                                "@Description": "CEDH 24x7 1yr"
                            },
                            {
                                "@IsSelected": "false",
                                "@Description": "CEE 24x7 1yr"
                            }
                        ]
                    },
                    License: {
                        "@IsSelected": "true",
                        "@Description": "None"
                    }
                }
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses = ServiceLicenses
            }
            if (this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] === undefined) {
                var AppStore = "false"
                var Deployment = "false"

                var SingleImage = {
                    "@Qty": "1",
                    "#text": "false"
                }
                var CustomImage = {
                    "@Qty": "1",
                    "#text": "false"
                }
                var Installation = "false"

                this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = AppStore
                this.props.workload.UserInputs.Environments.HadoopServices.SingleImage = SingleImage
                this.props.workload.UserInputs.Environments.HadoopServices.CustomImage = CustomImage
                this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] = Deployment
                this.props.workload.UserInputs.Environments.HadoopServices['Installation'] = Installation
            }
            if (!Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)) {
                // BluedataAIsftwreValue=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[1]['@Description']

                let License = [
                    {
                        "@Description": this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Description'],
                        "@IsSelected": "true",
                        "@Type": "BlueData"
                    },
                    {
                        "@Description": "None",
                        "@IsSelected": "true",
                        "@Type": "BlueDataAI"
                    }
                ]

                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License = License
            }


            if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                //////////////////1st Validation///////////////////////////////////////////
                HWEntDisabled = true
                if (HDFSSelected !== undefined) {
                    if ((HDFSSelected || YarnSelected || FlumeSelected || HBaseSelected || HiveSelected) && !KafkaSelected && !SparkSelected) {
                        HWEntDisabled = false
                    }
                    if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                        if (HWEntDisabled) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "HortonWork Enterprise":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                ///////2nd Validation///////////////////////////////////
                HwEntPlusDisabled = true
                if (HDFSSelected !== undefined) {
                    if (HDFSSelected || YarnSelected || FlumeSelected || HBaseSelected || HiveSelected || KafkaSelected || SparkSelected) {
                        HwEntPlusDisabled = false
                    }
                    if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                        if (HwEntPlusDisabled) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "HortonWork Enterprise Plus":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                //////3rd Validation////////////////////////////////////


                HwDataFlowDisabled = true
                if (HDFSSelected !== undefined) {
                    if (HDFSSelected || YarnSelected || FlumeSelected || HBaseSelected || HiveSelected || KafkaSelected || SparkSelected) {
                        HwDataFlowDisabled = false
                    }

                    if (HwDataFlowDisabled) {
                        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "Hortonworks DataFlow":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                //////4th Validation////////////////////////////////////////////////////////



                CLEraDataSciNdEngDisabled = true
                if (HDFSSelected !== undefined) {
                    if (HDFSSelected || YarnSelected || KafkaSelected || SparkSelected) {
                        CLEraDataSciNdEngDisabled = false
                    }

                    if (CLEraDataSciNdEngDisabled) {
                        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "Cloudera Data Engineering":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                //////5th Validation////////////////////////////////////////////////////////



                CLEraOpDBDisabled = true
                if (HDFSSelected !== undefined) {
                    if (HDFSSelected || YarnSelected || KafkaSelected || SparkSelected || HBaseSelected) {
                        CLEraOpDBDisabled = false
                    }

                    if (CLEraOpDBDisabled) {
                        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "Cloudera Operational Database":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                //////6th Validation////////////////////////////////////////////////////////



                CLEraAnalyDBDisabled = true
                if (HDFSSelected !== undefined) {
                    if (HDFSSelected || YarnSelected || KafkaSelected || SparkSelected || ImpalaSelected) {
                        CLEraAnalyDBDisabled = false
                    }

                    if (CLEraAnalyDBDisabled) {
                        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "Cloudera Analytical Database":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                //////7th Validation////////////////////////////////////////////////////////



                CLEraEntDataHubDisabled = true
                if (HDFSSelected !== undefined) {
                    if (HDFSSelected || YarnSelected || KafkaSelected || SparkSelected || ImpalaSelected || HBaseSelected) {
                        CLEraEntDataHubDisabled = false
                    }

                    if (CLEraEntDataHubDisabled) {
                        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "Cloudera Enterprise Data Hub":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                //////8th Validation////////////////////////////////////////////////////////



                CLEraESSDisabled = true
                if (HDFSSelected !== undefined) {
                    if (HDFSSelected || YarnSelected || KafkaSelected || SparkSelected || ImpalaSelected || HBaseSelected) {
                        CLEraESSDisabled = false
                    }

                    if (CLEraESSDisabled) {
                        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
                                switch (Servicename['@Type']) {

                                    case "Cloudera Essentials":
                                        Servicename['@IsSelected'] = "false"
                                        break;

                                }
                            })
                        }
                    }
                }
                //////////Common validations////////////////////////////////////////////////////////////////

                ClouderaLicensesDisabled = true
                HortonLicensesDisabled = true
                if (HDFSSelected || ScalitySelected || WekaSelected || HiveSelected || CassandraSelected || ImpalaSelected || HBaseSelected || SparkStreamSelected ||
                    KafkaSelected || FlumeSelected || NifiSelected || YarnSelected || SparkSelected || TensorflowSelected || PytorchSelected || MinifiSelected) {
                    ClouderaLicensesDisabled = false
                    HortonLicensesDisabled = false
                }
                if (HDFSSelected !== undefined) {
                    if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                        if (ClouderaLicensesDisabled) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] = "false"
                        }
                        if (HortonLicensesDisabled) {
                            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected'] = "false"
                        }
                    }
                }
            }
            //********************************************************************************************************************************************                   
            let BludeDataLinuxOptins = []

            if (this.props.ServicesInput.sessionDefaults !== undefined && this.props.ServicesInput.sessionDefaults !== null) {
                this.state.HPCMOptions = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.HPCM.Item;
                this.state.HWSupportOptions = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.HWSupport.Item;
                this.state.MapROPtions = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.MapR.Item;
                this.state.LinuxLicenseOptions = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.LinuxLicense.Item;
                this.state.ScalityOptions = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.Scality.Item;
                this.state.WekaOptions = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.Weka.Item;
                this.state.iLOLicenseOptions = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.iLOLicense.Item;
                // this.state.HadoopLicenseOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.HadoopLicense.HortonWorks.Item;
                VMWare_vCenter_Options = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(license => license["@Type"] === Constants.VMWARE_VCENTER).Item;
                VMWare_vSphere_Options = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(license => license["@Type"] === Constants.VMWARE_VSPHERE).Item;
                VMWare_vRealize_Options = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(license => license["@Type"] === Constants.VMWARE_VREALIZE).Item;
                VMWare_vSAN_Options = this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(license => license["@Type"] === Constants.VMWARE_VSAN).Item;
            }

            if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                    if (val['@Type'] === "Storage") {
                        if (Array.isArray(val.Service)) {
                            val.Service.filter((service) => {
                                if (service['@Selected'] === "true") {
                                    MapRXDDisabled = false;
                                    if (service["@Type"] === Constants.DATA_LAKE) {
                                        DataFabricServicesDisabled = false;
                                    }
                                }
                                if (service['@Type'] === "Scality" && service['@Selected'] === "false") {
                                    this.props.workload.UserInputs.Environments.HadoopServices['Scality'] = "None"
                                }
                                if (service['@Type'] === "MapR and MapR-EC" && service['@Selected'] === "false") {

                                    this.props.workload.UserInputs.Environments.HadoopServices['MapR'] = "None"
                                }
                                if (service['@Type'] === "Weka" && service['@Selected'] === "false") {
                                    this.props.workload.UserInputs.Environments.HadoopServices['Weka'] = "None"

                                }

                            })
                        }
                    }
                    if (val['@Type'] === "Database") {
                        if (Array.isArray(val.Service)) {
                            val.Service.filter((service) => {
                                if (service['@Selected'] === "true") {
                                    MapRDatabaseDisabled = false;
                                }
                            })
                        }
                    }
                    if (val['@Type'] === "Streaming") {
                        if (Array.isArray(val.Service)) {
                            val.Service.filter((service) => {
                                if (service['@Selected'] === "true") {
                                    MapRStreamsDisabled = false;
                                }
                            })
                        }
                    }
                    if (val['@Type'] === "Analytics") {
                        if (Array.isArray(val.Service)) {
                            val.Service.filter((service) => {
                                if (service['@Selected'] === "true") {
                                    MapRAnalyticsDisabled = false;
                                }
                                if (service["@Type"] == "Spark" && service['@Selected'] === "true") {
                                    MapRAnalyticswithSparkDisabled = false;
                                }
                            })
                        }
                    }
                })
                //Condition here is removed and written below if workoload type is BigData condition. 
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                    if (val['@Type'] === "Storage") {
                        val.Service.filter((service) => {
                            if (service['@Type'] === "Scality") {
                                if (service['@Selected'] === "true") {
                                    scalitydisplay = "Visible"
                                } else {
                                    scalitydisplay = "none";
                                }
                            }
                            if (service['@Type'] === "Weka") {
                                if (service['@Selected'] === "true") {
                                    Wekadisplay = "Visible"
                                } else {
                                    Wekadisplay = "none";
                                }
                            }

                        });
                    }
                });

                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.filter((Servicename) => {
                    switch (Servicename['@Type']) {
                        case Constants.DATAFABRIC_XD:
                            this.state.MapRXDChkBox = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case Constants.DATAFABRIC_ANALYTICS:
                            this.state.MapRAnalyticsChkBox = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case Constants.DATAFABRIC_SPARK:
                            this.state.MapRAnalyticswithSparkChkBox = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case Constants.DATAFABRIC_STREAMS:
                            this.state.MapRStreamsChkBox = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case Constants.DATAFABRIC_DATABASE:
                            this.state.MapRDatabaseChkBox = (/true/i).test(Servicename['@IsSelected'])
                            break;
                        case Constants.DATAFABRIC_BUNDLE:
                            this.state.MapRBundleChkBox = (/true/i).test(Servicename['@IsSelected'])
                            break;
                        case Constants.DATAFABRIC_SERVICES:
                            this.state.DataFabricServiceChkBox = (/true/i).test(Servicename["@IsSelected"]);
                    }
                })
            }

            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {

                if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter((Services) => {
                        if (Services['@Type'] === "Data Apps") {
                            KubernetesDataAppsValue = Services['@Description'];
                            this.state.KubernetesDataappsChBox = (/true/i).test(Services['@IsSelected'])
                        }
                        if (Services['@Type'] === "Data Apps Universal") {
                            this.state.KubernetesDataappsUniversalChBox = (/true/i).test(Services['@IsSelected'])
                        }
                        if (Services['@Type'] === "Data Apps w/ML Ops") {
                            KubernetesDataAppswMLOpsValue = Services['@Description'];
                            this.state.KubernetesDataappswMLOpsChBox = (/true/i).test(Services['@IsSelected'])
                        }
                        if (Services['@Type'] === "Data Apps Universal w/ML Ops") {
                            this.state.KubernetesDataappsUniversalwMLOpsChBox = (/true/i).test(Services['@IsSelected'])
                        }
                    })
                }



                this.state.CloudEraRadioBtn1 = (/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'])
                this.state.HortonRadioBtn1 = (/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected'])
                if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR['@IsSelected'] = "true";
                    overallConfigType = Constants.EPIC_;
                    this.props.workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_).map(selectedSolution => {
                        if (selectedSolution.Templates.Template.filter(template => template["@ConfigType"] === Constants.KUBERNETES_ && template['@Type'] !== Constants.NONE_).length > 0) {
                            overallConfigType = Constants.KUBERNETES_;
                        }
                    })
                }

                if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
                    this.state.MapRRadioBtn = (/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected']);
                }
                if (!this.state.HortonRadioBtn1 && !this.state.CloudEraRadioBtn1 && !this.state.MapRRadioBtn) {
                    this.state.NoneRadioBtn = true;
                }
                if (this.props.services.sessionDefaults !== undefined) {
                    this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.filter((name) => {
                        switch (name['@Type']) {
                            case "HortonWork Enterprise":
                                HortonWorkEntOptions = name.Item
                                break;

                            // case "HortonWork Enterprise Plus":
                            //     HortonWorkEntPlusOptions = name.Item
                            //     break;

                            case "Hortonworks DataFlow":
                                HortonWorkEntDataflowOptions = name.Item
                                break;

                            case "Cloudera Data Engineering":
                                ClouderaDataEngOptions = name.Item
                                break;

                            case "Cloudera Operational Database":
                                ClouderaOpDbOptions = name.Item
                                break;

                            case "Cloudera Analytical Database":
                                ClouderaAnaDbOptions = name.Item
                                break;

                            case "Cloudera Enterprise Data Hub":
                                ClouderaEntDataHubOptions = name.Item
                                break;

                            case "Cloudera Essentials":
                                ClouderaEssOptions = name.Item
                                break;
                            case "HPE Container Platform":
                                BluedataEpicsftwreOptions = name.Item
                                break;

                            case Constants.HPE_EZMERAL_MLOPS:
                                BluedataMLsftwreOptions = name.Item;
                                break;

                            case Constants.HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR:
                                externalK8sClusterMngrOptions = name.Item;
                                break;

                            case Constants.HPE_EZMERAL_DF_XD:
                                hpeEzmeralDataFabricLicenseOptions = name.Item;
                                break;

                            case "HPE Container Platform":
                                KubernetesHPECPOptions = name.Item
                                break;
                            case "Data Apps":
                                //KubernetesDataAppsOptions = name.Item
                                KubernetesDataAppsOptions = [name.Item]
                                break;
                            case "Data Apps Universal":
                                KubernetesDataAppsUniversalOptions = name.Item
                                break;
                            case "Data Apps w/ML Ops":
                                // KubernetesDataAppswMLOpsOptions = name.Item
                                KubernetesDataAppswMLOpsOptions = [name.Item]
                                break;
                            case "Data Apps Universal w/ML Ops":
                                KubernetesDataAppsUniversalwMLOpsOptions = name.Item
                                break;
                        }

                    })
                }
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter((Servicename) => {
                    switch (Servicename['@Type']) {
                        case "Cloudera Data Engineering":
                            ClouderaDataEngValue = Servicename['@Description']
                            this.state.CloudEraChBox4 = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case "Cloudera Operational Database":
                            ClouderaOpDbValue = Servicename['@Description']
                            this.state.CloudEraChBox5 = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case "Cloudera Analytical Database":
                            ClouderaAnaDbValue = Servicename['@Description']
                            this.state.CloudEraChBox6 = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case "Cloudera Enterprise Data Hub":
                            ClouderaEntDataHubValue = Servicename['@Description']
                            this.state.CloudEraChBox3 = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case "Cloudera Essentials":
                            ClouderaEssValue = Servicename['@Description']
                            this.state.CloudEraChBox2 = (/true/i).test(Servicename['@IsSelected'])
                            break;
                    }
                })
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter((Servicename) => {
                    switch (Servicename['@Type']) {
                        case "HortonWork Enterprise":
                            HortonWorkEntValue = Servicename['@Description']
                            if (Servicename[Constants.ATTRIBUTE_DESCRIPTION] === Constants.NONE_) {
                                Servicename[Constants.ATTRIBUTE_ISSELECTED] = Constants.fALSE_;
                            } else {
                                Servicename[Constants.ATTRIBUTE_ISSELECTED] = Constants.tRUE_;
                            }
                            this.state.HortonRadioBtn2 = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case "HortonWork Enterprise Plus":
                            HortonWorkEntPlusValue = Servicename['@Description']
                            this.state.HortonRadioBtn3 = (/true/i).test(Servicename['@IsSelected'])
                            break;

                        case "Hortonworks DataFlow":
                            HortonWorkEntDataflowValue = Servicename['@Description']
                            this.state.HortonChBox4 = (/true/i).test(Servicename['@IsSelected'])
                            break;
                    }
                })
            }

            Clouderadisply = 'none';
            Hortondisply = 'none';
            MapRContentdisplay = 'none';
            if (this.state.HortonRadioBtn1) {
                Hortondisply = ' ';
                Clouderadisply = 'none';
                MapRContentdisplay = 'none';
            }
            else if (this.state.CloudEraRadioBtn1) {
                Hortondisply = 'none';
                Clouderadisply = ' ';
                MapRContentdisplay = 'none';
            }
            else if (this.state.MapRRadioBtn) {
                Hortondisply = 'none';
                Clouderadisply = 'none';
                MapRContentdisplay = ' ';
            }
            else if (this.state.NoneRadioBtn) {
                Hortondisply = Constants.nONE_;
                Clouderadisply = Constants.nONE_;
                MapRContentdisplay = Constants.nONE_;
            }

            if (!this.state.HortonRadioBtn2) {
                HortonWorkEntValue = 'None';
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(x => x["@Type"] === "HortonWork Enterprise")["@Description"] = "None"
                }
            }
            if (!this.state.HortonRadioBtn3) {
                HortonWorkEntPlusValue = 'None'; HortonWorkEntPlusOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(x => x["@Type"] === "HortonWork Enterprise Plus")["@Description"] = "None"
                }
            }
            if (!this.state.HortonChBox4) {
                HortonWorkEntDataflowValue = 'None'; HortonWorkEntDataflowOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') { this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(x => x["@Type"] === "Hortonworks DataFlow")["@Description"] = "None" }
            }

            if (!this.state.CloudEraChBox2) {
                ClouderaEssValue = 'None'; ClouderaEssOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(x => x["@Type"] === "Cloudera Essentials")["@Description"] = "None"
                }
            }
            if (!this.state.CloudEraChBox3) {
                ClouderaEntDataHubValue = 'None'; ClouderaEntDataHubOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(x => x["@Type"] === "Cloudera Enterprise Data Hub")["@Description"] = "None"
                }
            }
            if (!this.state.CloudEraChBox4) {
                ClouderaDataEngValue = 'None'; ClouderaDataEngOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(x => x["@Type"] === "Cloudera Data Engineering")["@Description"] = "None"
                }
            }
            if (!this.state.CloudEraChBox5) {
                ClouderaOpDbValue = 'None'; ClouderaOpDbOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(x => x["@Type"] === "Cloudera Operational Database")["@Description"] = "None"
                }
            }
            if (!this.state.CloudEraChBox6) {
                ClouderaAnaDbValue = 'None'; ClouderaAnaDbOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(x => x["@Type"] === "Cloudera Analytical Database")["@Description"] = "None"
                }
            }

            if (!this.state.KubernetesHPECPChBox) { KubernetesHPECPValue = 'None'; KubernetesHPECPOptions = []; }
            if (!this.state.KubernetesDataappsChBox) {
                KubernetesDataAppsValue = 'None'; KubernetesDataAppsOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(x => x["@Type"] === "Data Apps")["@Description"] = "None"
                }
            }
            if (!this.state.KubernetesDataappsUniversalChBox) {
                KubernetesDataAppsUniversalValue = 'None'; KubernetesDataAppsUniversalOptions = [];
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') { this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(x => x["@Type"] === "Data Apps Universal")["@Description"] = "None" }
            }
            if (!this.state.KubernetesDataappswMLOpsChBox) { KubernetesDataAppswMLOpsValue = 'None'; KubernetesDataAppswMLOpsOptions = []; if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') { this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(x => x["@Type"] === "Data Apps w/ML Ops")["@Description"] = "None" } }
            if (!this.state.KubernetesDataappsUniversalwMLOpsChBox) { KubernetesDataAppsUniversalwMLOpsValue = 'None'; KubernetesDataAppsUniversalwMLOpsOptions = []; if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') { this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(x => x["@Type"] === "Data Apps Universal w/ML Ops")["@Description"] = "None" } }

            if (this.props.workload.UserInputs.Environments.HadoopServices.SingleImage !== undefined) {
                SingleQtyVal = this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty']
                CustomQtyVal = this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty']
                this.state.AppStoreCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices['AppStore']))
                this.state.SingleImageCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']))
                this.state.EPICCustomCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']))
                this.state.DeploymentCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices['Deployment']))
                this.state.InstallationCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices['Installation']))
                if (this.state.SingleImageCheckbox) {
                    this.state.AppStoreCheckbox = true
                    this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = 'true'
                } else {
                    this.state.AppStoreCheckbox = false
                    this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = 'false'
                }
            }
            //*************************************************************************************************************** */
            // ToolTips//
            let HWEntTooltip = 'Supported services : Data Lake, YARN, Flume, Hbase, Hive'
            let HWEntPlusTooltip = 'Supported services : Data Lake, YARN, Flume, Hbase, Hive, Kafka, Spark'
            let HWEntDataFlowTooltip = 'Supported services : Data Lake, YARN, Flume, Hbase, Hive, Kafka, Spark'
            let CLEraEssTooltip = 'Supported services : Data Lake, YARN, Spark, Impala, Kafka, Hbase'
            let CLEraEntDataHubTooltip = 'Supported services : Data Lake, YARN, Spark, Impala, Kafka, Hbase'
            let CLEraDataSciNdEngTooltip = 'Supported services : Data Lake, YARN, Spark, Kafka'
            let CLEraOptDBTooltip = 'Supported services : Data Lake, YARN, Spark, Kafka, Hbase'
            let CLEraAnalDBTooltip = 'Supported services : Data Lake, YARN, Spark, Impala, Kafka'
            var BigDataUI = '';
            var BluedataUI = '';

            if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                let EnableEPICandAI = false
                var AddservicesInstallDissable = false
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((services) => {
                            if (services["@Selected"] === "true") {
                                if (services.Inputs["@BlueData"] == "true") {
                                    EnableEPICandAI = true;
                                }
                            }
                        })
                    }
                    else {
                        if (val.Service["@Selected"] === "true") {
                            if (val.Service.Inputs !== undefined && val.Service.Inputs["@BlueData"] == "true") {
                                EnableEPICandAI = true;
                            }
                        }
                    }
                })
                if (!EnableEPICandAI) {
                    AddservicesInstallDissable = true
                    this.props.workload.UserInputs.Environments.HadoopServices['Installation'] = "false"
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@Description'] = Constants.NONE_
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@Description'] = Constants.NONE_
                    BluedataEpicsftwreOptions = []
                    BluedataMLsftwreOptions = []
                    BlueDataMLDisabled = true
                    BlueDataEpicDisabled = true
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@IsSelected'] = Constants.fALSE_
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@IsSelected'] = Constants.fALSE_
                } else {
                    BlueDataMLDisabled = false
                    BlueDataEpicDisabled = false
                }
            }
            if (Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)) {
                this.state.BlueDataEpicChecked = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@IsSelected']))
                if (this.state.BlueDataEpicChecked === false) {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@Description'] = Constants.NONE_
                    BluedataEpicsftwreOptions = []
                }
                BluedataEpicsftwreValue = this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM)['@Description'];
                if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
                    hpeEzmeralDataFabricLicense = this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_EZMERAL_DF_XD)['@Description'];
                }

            }
            //BlueData AI Software implementation 
            if (Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)) {
                if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                    this.state.BlueDataMLChecked = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@IsSelected']))

                    if (this.state.BlueDataMLChecked === false) {
                        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@Description'] = "None"
                        BluedataMLsftwreOptions = []
                    }
                }
                BluedataMLsftwreValue = this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@Description']
                if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
                    kubernetesCM = this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === "Kubernetes CM")['@Description']
                }

            }
            BluedataUI = <FormField style={{ width: '29%', marginBottom: '10px' }} ><RadioButton disabled={BlueDataEpicDisabled} id='BlueEPIC' label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>HPE Ezmeral {Constants.RE} Software </Paragraph> <CircleInformation data-tip={'A HPE Ezmeral ' + Constants.RE + ' license is required. Select the term of the support desired.'} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.BlueDataEpicChecked} onChange={this.onBlueDataRadioBtnChange} style={{ overflow: "hidden", width: '62%' }} />
                <Select placeHolder='None' value={BluedataEpicsftwreValue} options={BluedataEpicsftwreOptions} onChange={(e) => this.OnBlueDataChange(e, "BlueData EPIC Software")} />
            </FormField >

            var AddservicesDissable = false
            if (BluedataEpicsftwreValue === "None" && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration['@Type'] === "EPIC" && this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = "false"
                this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text'] = "false"
                this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text'] = "false"
                this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] = "false"
                //this.props.workload.UserInputs.Environments.HadoopServices['Installation']="false"
                AddservicesDissable = true

            }
            if (this.props.workload.UserInputs.Environments.HadoopServices.SingleImage !== undefined) {
                SingleQtyVal = this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty']
                CustomQtyVal = this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty']
                this.state.AppStoreCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices['AppStore']))
                this.state.SingleImageCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']))
                this.state.EPICCustomCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']))
                this.state.DeploymentCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices['Deployment']))
                this.state.InstallationCheckbox = ((/true/i).test(this.props.workload.UserInputs.Environments.HadoopServices['Installation']))
                if (this.state.SingleImageCheckbox) {
                    this.state.AppStoreCheckbox = true
                    this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = 'true'
                } else {
                    this.state.AppStoreCheckbox = false
                    this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = 'false'
                }
            }
            var ExtraServices = '';

            if (overallConfigType === Constants.KUBERNETES_ || (overallConfigType === Constants.EPIC_ && this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData')) {
                AddservicesInstallDissable = false;
                AddservicesDissable = false;
            }

            if (this.state.DeploymentCheckbox) {
                let quickStartChecked = false
                let EssentialChecked = false
                let AdvancedChecked = false
                let PremiumChecked = false
                let CustomChecked = false
                var BludeDataCount = 0;
                if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
                    this.props.workload.UserInputs.Environments.Environment.map(solution => {
                        solution.Templates.ServerDetails.Server.map(role => {
                            BludeDataCount = this.calculateBlueDataCount(role, BludeDataCount);
                        })
                    })
                    this.props.workload.UserInputs.Environments.ManagementHosts.Server.map(role => {
                        BludeDataCount = this.calculateBlueDataCount(role, BludeDataCount);
                    })
                } else if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
                    var HDFSDataCount = 0;
                    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                        if (val['@Type'] === "Storage") {
                            val.Service.filter((services) => {
                                if (services["@Selected"] === "true") {
                                    if (services["@Type"] == Constants.DATA_LAKE && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Scality" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Weka" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                }

                            })
                        }
                        if (val['@Type'] === "Database") {
                            val.Service.filter((services) => {
                                if (services["@Selected"] === "true") {
                                    if (services["@Type"] == "Hive" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Cassandra" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Impala" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "HBase" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                }

                            })
                        }
                        if (val['@Type'] === "Streaming") {
                            val.Service.filter((services) => {
                                if (services["@Selected"] === "true") {
                                    if (services["@Type"] == "Spark Streaming" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Kafka" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Flink" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Storm" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                }

                            })
                        }
                        if (val['@Type'] === "Analytics") {
                            val.Service.filter((services) => {
                                if (services["@Selected"] === "true") {
                                    if (services["@Type"] == "Yarn" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "Spark" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                }

                            })
                        }
                        if (val['@Type'] === "AI") {
                            val.Service.filter((services) => {
                                if (services["@Selected"] === "true") {
                                    if (services["@Type"] == "Tensorflow" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                    if (services["@Type"] == "PyTorch" && services.Inputs["@BlueData"] == "true" && (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(services.Hardware['@Server']) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = services.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                }

                            })
                        }
                        if (val['@Type'] === "IoT") {
                            if (Array.isArray(val)) {
                                val.Service.filter((services) => {
                                    if (services["@Selected"] === "true") {
                                        if (services["@Type"] == "MiNifi" && services.Inputs["@BlueData"] == "true" && (services.Hardware['@ServerName'].indexOf(Constants.E910) !== -1 || services.Hardware['@ServerName'].indexOf(Constants.EL4000) !== -1)) {
                                            let ProcContrl = []
                                            let CoreContrl = []
                                            ProcContrl = services.Hardware["@Proc"].split("/");
                                            CoreContrl = ProcContrl[2].split(" ")
                                            HDFSDataCount += parseInt(services.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                        }
                                    }

                                })
                            } else {
                                if (val.Service["@Selected"] === "true") {
                                    if (val.Service["@Type"] == "MiNifi" && val.Service.Inputs["@BlueData"] == "true" && (val.Service.Hardware['@ServerName'].indexOf(Constants.E910) !== -1 || val.Service.Hardware['@ServerName'].indexOf(Constants.EL4000) !== -1)) {
                                        let ProcContrl = []
                                        let CoreContrl = []
                                        ProcContrl = val.Service.Hardware["@Proc"].split("/");
                                        CoreContrl = ProcContrl[2].split(" ")
                                        HDFSDataCount += parseInt(val.Service.Hardware["@NodesCount"], 10) * 2 * parseInt(CoreContrl[1], 10);
                                    }
                                }
                            }
                        }

                    })
                    BludeDataCount = HDFSDataCount;

                }

                if (BludeDataCount <= 100) {
                    quickStartChecked = true
                    EssentialChecked = false
                    AdvancedChecked = false
                    PremiumChecked = false
                    CustomChecked = false
                }
                else if (BludeDataCount > 100 && BludeDataCount <= 240) {
                    quickStartChecked = false
                    EssentialChecked = true
                    AdvancedChecked = false
                    PremiumChecked = false
                    CustomChecked = false
                } else if (BludeDataCount > 240 && BludeDataCount <= 480) {
                    quickStartChecked = false
                    EssentialChecked = false
                    AdvancedChecked = true
                    PremiumChecked = false
                    CustomChecked = false
                } else if (BludeDataCount > 480 && BludeDataCount <= 1200) {
                    quickStartChecked = false
                    EssentialChecked = false
                    AdvancedChecked = false
                    PremiumChecked = true
                    CustomChecked = false
                } else if (BludeDataCount > 1200) {
                    quickStartChecked = false
                    EssentialChecked = false
                    AdvancedChecked = false
                    PremiumChecked = false
                    CustomChecked = true
                }
                ExtraServices = <Box pad={{ 'between': 'small' }} style={{ border: '2px solid rgba(0,0,0,0.48)', borderRadius: '20px', paddingBottom: '25px' }}>
                    <Box direction="row" pad={{ 'between': 'small' }} style={{ marginLeft: '4.5%' }}>
                        <CheckBox className='LatestLicenses' disabled={true} label="QuickStart" checked={quickStartChecked} style={{ overflow: "hidden" }} />
                        <CheckBox className='LatestLicenses' disabled={true} label="Essential" checked={EssentialChecked} style={{ overflow: "hidden" }} />
                        <CheckBox className='LatestLicenses' disabled={true} label="Advanced" checked={AdvancedChecked} style={{ overflow: "hidden", }} />
                    </Box>
                    <Box direction="row" pad={{ 'between': 'small' }} style={{ marginLeft: '4.5%' }}>
                        <CheckBox className='LatestLicenses' disabled={true} label="Premium" checked={PremiumChecked} style={{ overflow: "hidden", }} />
                        <div style={{ margin: '27px 0px 0px 9px' }}><CheckBox className='LatestLicenses' disabled={true} label="Custom" checked={CustomChecked} style={{ overflow: "hidden", }} /></div>
                    </Box>
                </Box>
            }

            if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                if (!MapRXDDisabled) {
                    let shouldEnableMapR = false;
                    this.props.workload.UserInputs.Environments.Functions.Function.find(Function => Function["@Type"] === "Storage").Service.map(val => {
                        if (val["@Selected"] === "true") {
                            let storage = 0;
                            let diskQty = 0;
                            const updateStorageDisk = (disk) => {
                                let capacity = disk.Item["@disk"].split(' ')[1];
                                if (disk.Item["@disk"].indexOf(Constants.TB_) !== -1) {
                                    storage += parseFloat(capacity.split(Constants.TB_)[0], 10);
                                }
                                else if (disk.Item["@disk"].indexOf(Constants.GB_) !== -1) {
                                    storage += parseFloat(capacity.split(Constants.GB_)[0] / 1024, 10);
                                }
                                diskQty += disk.Item["@qty"];
                            }
                            if (Array.isArray(val.DataDisks)) {
                                if (val.DataDisks.length > 0) {
                                    val.DataDisks.map(disk => {
                                        updateStorageDisk(disk);
                                    })
                                }
                            } else {
                                updateStorageDisk(val.DataDisks);
                            }
                            let dataLakeStorageSize = parseInt(val.Hardware["@NodesCount"], 10) * parseInt(storage, 10) * parseInt(diskQty, 10);
                            if (dataLakeStorageSize > 100) {
                                shouldEnableMapR = true;
                                if (val["@Type"] === Constants.DATA_LAKE && dataLakeStorageSize > 10000) {
                                    DataFabricServicesDisabled = true;
                                    datalakeServiceNote = <Paragraph style={{ maxWidth: '100%', fontSize: '16px', marginTop: '15px', color: 'red' }}><b>Note : Contact HPE Solution Architect to request a quote for Data Fabric services.</b></Paragraph>
                                }
                            }
                        }
                    })
                    if (!shouldEnableMapR) {
                        MapRXDDisabled = true;
                    }
                }
                if (MapRXDDisabled) {
                    MapRAnalyticsDisabled = true;
                    MapRAnalyticswithSparkDisabled = true;
                    MapRStreamsDisabled = true;
                    MapRDatabaseDisabled = true;
                    MapRBundleDisabled = true;
                }


                if (MapRXDDisabled === false || MapRAnalyticsDisabled === false || MapRAnalyticswithSparkDisabled === false || MapRStreamsDisabled === false || MapRDatabaseDisabled === false) {
                    MapRBundleDisabled = false;
                }
                if (MapRXDDisabled) {
                    this.state.MapRXDChkBox = false;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(x => x["@Type"] === Constants.DATAFABRIC_XD)["@IsSelected"] = Constants.fALSE_;
                }
                if (MapRAnalyticsDisabled) {
                    this.state.MapRAnalyticsChkBox = false;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(x => x["@Type"] === Constants.DATAFABRIC_ANALYTICS)["@IsSelected"] = Constants.fALSE_;
                }
                if (MapRAnalyticswithSparkDisabled) {
                    this.state.MapRAnalyticswithSparkChkBox = false;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(x => x["@Type"] === Constants.DATAFABRIC_SPARK)["@IsSelected"] = Constants.fALSE_;
                }
                if (MapRStreamsDisabled) {
                    this.state.MapRStreamsChkBox = false;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(x => x["@Type"] === Constants.DATAFABRIC_STREAMS)["@IsSelected"] = Constants.fALSE_;
                }
                if (MapRDatabaseDisabled) {
                    this.state.MapRDatabaseChkBox = false;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(x => x["@Type"] === Constants.DATAFABRIC_DATABASE)["@IsSelected"] = Constants.fALSE_;
                }
                if (MapRBundleDisabled) {
                    this.state.MapRBundleChkBox = false;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(x => x["@Type"] === Constants.DATAFABRIC_BUNDLE)["@IsSelected"] = Constants.fALSE_;
                }
                if (DataFabricServicesDisabled) {
                    this.state.DataFabricServiceChkBox = false;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(x => x["@Type"] === Constants.DATAFABRIC_SERVICES)["@IsSelected"] = Constants.fALSE_;
                }
            }

            if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
                VMWareLicenses = (
                    <Box size="xlarge" separator="all" pad='none' margin='none' style={{ width: '95%', marginTop: '5px' }}>
                        <Heading tag='h6' strong={true} style={{ marginLeft: '10px', marginTop: '5px' }}>VMWare Licenses</Heading>
                        <Box direction="row" align='start' wrap={false} pad={{ between: 'small' }} margin='medium' style={{ marginTop: '10px', flexWrap: "wrap", width: '100%', marginLeft: '4.5%' }}>
                            <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.VMWARE_VCENTER}</Paragraph>
                                <CircleInformation data-tip={VMWare_VCenterTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ marginBottom: '5px', width: '320px' }}>
                                <Select placeHolder='None' value={this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vCenter"]} options={VMWare_vCenter_Options} onChange={(e) => this.OnLicenseChange(e, Constants.VMWARE_VCENTER)} />
                            </FormField>
                            <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.VMWARE_VSPHERE}</Paragraph>
                                <CircleInformation data-tip={VMWare_VSphereTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ marginBottom: '5px', width: '320px' }}>
                                <Select placeHolder='None' value={this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vSphere"]} options={VMWare_vSphere_Options} onChange={(e) => this.OnLicenseChange(e, Constants.VMWARE_VSPHERE)} />
                            </FormField>
                        </Box>
                    </Box>);
            }

            return (
                <Box pad='none' margin='none' style={{ position: 'relative', width: '100%', overflow: "none", paddingLeft: '10px' }}>
                    <Warning message={Constants.HPECP_WARNING_MESSAGE} isEnabled={!this.props.displayWarning} history={this.props.history} />
                    <Article full={true} margin="none" pad={{ between: 'small' }} style={{ maxHeight: '96%', overflowX: 'hidden' }} >
                        <Box margin="none" pad="none" style={{ width: '100%' }}>
                            <ReactTooltip place="right" multiline={true} />
                            <Box align='start' size="" wrap={true} pad='none' margin='none' style={{ width: '100%' }}>
                                <Box direction='row' align='start' size="large" wrap={true} pad='none' margin='none' style={{ width: '95%' }} >
                                    <Box justify='start' margin="none" pad={{ between: 'small' }} style={{ paddingTop: '12px', width: '100%' }}>
                                        <Box style={{ borderBottom: '1px solid gray' }} margin='none' pad='none'><Heading style={{ marginBottom: '5px' }} tag='h4' strong={true} >Licenses</Heading></Box>

                                    </Box>
                                </Box >
                                <Box size="xlarge" separator="all" pad='none' margin='none' style={{ width: '95%', marginTop: '5px', display: 'none' }}>
                                    <Box align='start' wrap={true} size="xlarge" pad='none' margin='none' style={{ width: '95%', paddingLeft: "10px" }}>
                                        {/* <Heading tag='h6' strong={true} style={{ marginLeft: '10px', marginTop: '5px' }}>{Constants.DATA_LAKE} Services</Heading>
                                        <Box style={{ width: '80%', marginBottom: '25px', marginTop: '1%', fontWeight: '600' }} direction='row'>
                                            <RadioButton id='choice1-1' name='choice11' label='Hortonworks Licenses' disabled={HortonLicensesDisabled} checked={this.state.HortonRadioBtn1} onChange={this.onHortonRadioBtnChange} />
                                            <RadioButton id='choice1-2' name='choice11' label='Cloudera Licenses' disabled={ClouderaLicensesDisabled} checked={this.state.CloudEraRadioBtn1} onChange={this.onHortonRadioBtnChange} />
                                            {this.props.workload.UserInputs.Environments.WorkloadType === "BigData" ? 
                                            <RadioButton id='choice1-3' name='choice11' label={Constants.HPE_EZMERAL_DATAFABRIC} disabled={false} checked={this.state.MapRRadioBtn} onChange={this.onHortonRadioBtnChange} />:''
                                            }
                                            <RadioButton id={Constants.NONE_RADBTN_ID} name='choice11' label={Constants.NONE_} checked={this.state.NoneRadioBtn} onChange={this.onHortonRadioBtnChange} />
                                        </Box> */}
                                        <Box direction='row' pad={{ between: 'small' }} style={{ marginLeft: '5%', marginBottom: '1%', width: '95%', display: Hortondisply }}>
                                            <FormField style={{ width: '93%' }} className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Hortonworks Enterprise</Paragraph>
                                                <CircleInformation data-tip={HWEntTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ overflow: "hidden", width: '62%' }}>
                                                <Select placeHolder='None' value={HortonWorkEntValue} options={HortonWorkEntOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'HortonWorkEntValue') }} />
                                            </FormField>

                                            {/* <FormField className="DiskCapacityDetails"><RadioButton disabled={HwEntPlusDisabled} id='EntPlus' label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Hortonworks Ent Plus</Paragraph>
                                                <CircleInformation data-tip={HWEntPlusTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.HortonRadioBtn3} onChange={this.onHortoninsideRadioBtnChange} style={{ overflow: "hidden", width: '62%' }} />
                                                <Select placeHolder='None' value={HortonWorkEntPlusValue} options={HortonWorkEntPlusOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'HortonWorkEntPlusValue') } } />
                                            </FormField> */}

                                            <FormField className="DiskCapacityDetails"><CheckBox disabled={HwDataFlowDisabled} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Hortonworks Ent Data Flow</Paragraph>
                                                <CircleInformation data-tip={HWEntDataFlowTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.HortonChBox4} onChange={(e) => this.onHortonChBoxChange(e, "HortonWorkEntDataflowValue")} style={{ overflow: "hidden", width: '62%' }} />
                                                <Select placeHolder='None' value={HortonWorkEntDataflowValue} options={HortonWorkEntDataflowOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'HortonWorkEntDataflowValue') }} />
                                            </FormField>
                                        </Box>
                                        <Box align='start' wrap={true} size="xlarge" pad='none' margin='none' style={{ width: '100%', display: Clouderadisply }}>
                                            <Box direction='row' pad={{ between: 'small' }} style={{ marginLeft: '5%', marginBottom: '1%', width: '95%' }}>
                                                <FormField className="DiskCapacityDetails">
                                                    <CheckBox disabled={CLEraESSDisabled} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Cloudera Essentials</Paragraph>
                                                        <CircleInformation data-tip={CLEraEssTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.CloudEraChBox2} onChange={(e) => this.onClouderaESSChBoxChange(e, "ClouderaEssValue")} style={{ overflow: "hidden", width: '62%' }} />
                                                    <Select placeHolder='None' value={ClouderaEssValue} options={ClouderaEssOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'ClouderaEssValue') }} />
                                                </FormField>
                                                <FormField className="DiskCapacityDetails"><CheckBox disabled={CLEraEntDataHubDisabled} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Cloudera Ent Data Hub</Paragraph>
                                                    <CircleInformation data-tip={CLEraEntDataHubTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.CloudEraChBox3} onChange={(e) => this.onClouderaEntDataHubChBoxChange(e, "ClouderaEntDataHubValue")} style={{ overflow: "hidden", width: '62%' }} />
                                                    <Select placeHolder='None' value={ClouderaEntDataHubValue} options={ClouderaEntDataHubOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'ClouderaEntDataHubValue') }} />
                                                </FormField>
                                                <FormField className="DiskCapacityDetails"><CheckBox disabled={CLEraDataSciNdEngDisabled} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Cloudera Data Engineering</Paragraph>
                                                    <CircleInformation data-tip={CLEraDataSciNdEngTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.CloudEraChBox4} onChange={(e) => this.onClouderaDataEngChBoxChange(e, "ClouderaDataEngValue")} style={{ overflow: "hidden", width: '62%' }} />
                                                    <Select placeHolder='None' value={ClouderaDataEngValue} options={ClouderaDataEngOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'ClouderaDataEngValue') }} />
                                                </FormField>

                                            </Box>
                                            <Box direction='row' pad={{ between: 'small' }} style={{ marginLeft: '5%', marginBottom: '1%', width: '63%' }}>
                                                <FormField className="DiskCapacityDetails"><CheckBox disabled={CLEraOpDBDisabled} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Cloudera Opt Database</Paragraph>
                                                    <CircleInformation data-tip={CLEraOptDBTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.CloudEraChBox5} onChange={(e) => this.onClouderaOpDBChBoxChange(e, "ClouderaOpDbValue")} style={{ overflow: "hidden", width: '62%' }} />
                                                    <Select placeHolder='None' value={ClouderaOpDbValue} options={ClouderaOpDbOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'ClouderaOpDbValue') }} />
                                                </FormField>
                                                <FormField className="DiskCapacityDetails"><CheckBox disabled={CLEraAnalyDBDisabled} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Cloudera Analytical DB</Paragraph>
                                                    <CircleInformation data-tip={CLEraAnalDBTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.CloudEraChBox6} onChange={(e) => this.onClouderaAnaDBChBoxChange(e, "ClouderaAnaDbValue")} style={{ overflow: "hidden", width: '62%' }} />
                                                    <Select placeHolder='None' value={ClouderaAnaDbValue} options={ClouderaAnaDbOptions} onChange={(e) => { this.OnServicedrpdwnChange(e, 'ClouderaAnaDbValue') }} />
                                                </FormField>
                                            </Box>
                                        </Box>
                                        {(this.props.workload.UserInputs.Environments.WorkloadType === 'BigData' && this.state.MapRRadioBtn) ?
                                            <Box align='start' wrap={true} size="xlarge" pad='none' margin='none' style={{ width: '100%', display: MapRContentdisplay }}>
                                                <Box direction="row" pad={{ between: 'small' }} style={{ width: '100%', marginBottom: '15px' }}>
                                                    <Box direction="row" style={{ width: '30%' }}>
                                                        <CheckBox id="XD" disabled={MapRXDDisabled} label={
                                                            <Box direction='row'>
                                                                <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.HPE_EZMERAL_DF_FILE_STORE}</Paragraph>
                                                                <CircleInformationIcon data-tip={'Supported services: Data Lake, Scality and Weka'} data-for='XDt' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                            </Box>
                                                        }
                                                            checked={this.state.MapRXDChkBox} onChange={(e) => this.onMapRcheckBoxChange(e, Constants.DATAFABRIC_XD)} style={{ overflow: "hidden" }} />
                                                        <ReactTooltip place="right" type="dark" effect="solid" id='XDt'></ReactTooltip>
                                                    </Box>
                                                    <Box style={{ width: '30%' }}>
                                                        <CheckBox id="Analytics" disabled={MapRAnalyticsDisabled} label={
                                                            <Box direction='row'>
                                                                <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.HPE_EZMERAL_DF_ANALYTICS}</Paragraph>         {/* width reduced to 6% from 62 by Aditya, issue raised by bharat */}
                                                                <CircleInformationIcon data-tip={'Supported services: Yarn and Spark'} data-for='Analyticst' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                            </Box>
                                                        }
                                                            checked={this.state.MapRAnalyticsChkBox} onChange={(e) => this.onMapRcheckBoxChange(e, Constants.DATAFABRIC_ANALYTICS)} style={{ overflow: "hidden" }} />
                                                        <ReactTooltip place="right" type="dark" effect="solid" id='Analyticst'></ReactTooltip>
                                                    </Box>
                                                    <Box style={{ width: '30%' }}>
                                                        <CheckBox id="Spark" disabled={MapRAnalyticswithSparkDisabled} label={
                                                            <Box direction='row'>
                                                                <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.HPE_EZMERAL_DF_SPARK}</Paragraph>
                                                                <CircleInformationIcon data-tip={'Supported services: Spark'} data-for='Sparkt' colorIndex="accent-3" style={{ height: "20px" }} />
                                                            </Box>}
                                                            checked={this.state.MapRAnalyticswithSparkChkBox} onChange={(e) => this.onMapRcheckBoxChange(e, Constants.DATAFABRIC_SPARK)} style={{ overflow: "hidden" }} /></Box>
                                                    <ReactTooltip place="right" type="dark" effect="solid" id='Sparkt'></ReactTooltip>
                                                </Box>
                                                <Box direction="row" pad={{ between: 'small' }} style={{ width: '100%', marginBottom: '10px' }}>
                                                    <Box style={{ width: '30%' }}>
                                                        <CheckBox id="Streams" disabled={MapRStreamsDisabled} label={
                                                            <Box direction='row'>
                                                                <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.HPE_EZMERAL_DF_STREAMS}</Paragraph>
                                                                <CircleInformationIcon data-tip={'Supported services: Spark Streaming, Kafka, Flink and Storm'} data-for='Streamst' colorIndex="accent-3" style={{ height: "20px" }} />
                                                            </Box>}
                                                            checked={this.state.MapRStreamsChkBox} onChange={(e) => this.onMapRcheckBoxChange(e, Constants.DATAFABRIC_STREAMS)} style={{ overflow: "hidden", width: '6%' }} />
                                                        <ReactTooltip place="right" type="dark" effect="solid" id='Streamst'></ReactTooltip>
                                                    </Box>
                                                    <Box style={{ width: '30%' }}><CheckBox id="Database" disabled={MapRDatabaseDisabled} label={<Box direction='row' ><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.HPE_EZMERAL_DF_DATABASE}</Paragraph>
                                                        <CircleInformationIcon data-tip={'Supported services: Hive, Cassandra, Impala and HBase'} data-for='Databaset' colorIndex="accent-3" style={{ height: "20px" }} />
                                                    </Box>}
                                                        checked={this.state.MapRDatabaseChkBox} onChange={(e) => this.onMapRcheckBoxChange(e, Constants.DATAFABRIC_DATABASE)} style={{ overflow: "hidden", width: '6%' }} />
                                                        <ReactTooltip place="right" type="dark" effect="solid" id='Databaset'></ReactTooltip>
                                                    </Box>
                                                    <Box style={{ width: '30%' }}><CheckBox id="Bundle" disabled={MapRBundleDisabled} label={
                                                        <Box direction='row'>
                                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.HPE_EZMERAL_DF_BUNDLE}</Paragraph>
                                                            <CircleInformationIcon data-tip={'Bundle includes MapR XD, MapR Analytics, MapR Analytics with Spark, MapR Streams and MapR Database.'} data-for='Bundlet' colorIndex="accent-3" style={{ height: "20px" }} />
                                                        </Box>}
                                                        checked={this.state.MapRBundleChkBox} onChange={(e) => this.onMapRcheckBoxChange(e, Constants.DATAFABRIC_BUNDLE)} style={{ overflow: "hidden", width: '6%' }} /></Box>

                                                    <ReactTooltip place="right" type="dark" effect="solid" id='Bundlet'></ReactTooltip>
                                                </Box>
                                                <Box direction="row" style={{ width: '100%' }}>
                                                    <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>HPE Ezmeral Data Fabric License</Paragraph>
                                                        <CircleInformation data-tip='' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ marginBottom: '5px', marginTop: '5px', width: '30%' }}>
                                                        <Select placeHolder='None' value={hpeEzmeralDataFabricLicense} options={hpeEzmeralDataFabricLicenseOptions} onChange={(e) => { this.OnBlueDataChange(e, Constants.HPE_EZMERAL_DF_XD) }} />
                                                    </FormField>
                                                    <Box style={{ width: '45%', marginTop: '15px', marginLeft: '15px' }}><CheckBox id={Constants.SERVICES_} disabled={DataFabricServicesDisabled} label={
                                                        <Box direction='row'>
                                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.DATAFABRIC_SERVICES}</Paragraph>
                                                            <CircleInformationIcon data-tip={'Supported services: Data Lake'} data-for={`${Constants.SERVICES_}t`} colorIndex="accent-3" style={{ height: "20px" }} />
                                                        </Box>}
                                                        checked={this.state.DataFabricServiceChkBox} onChange={(e) => this.onMapRcheckBoxChange(e, Constants.DATAFABRIC_SERVICES)} style={{ overflow: "hidden", width: '6%' }} />
                                                        <ReactTooltip place="right" type="dark" effect="solid" id={`${Constants.SERVICES_}t`}></ReactTooltip>
                                                    </Box>
                                                </Box>
                                                {datalakeServiceNote}
                                            </Box> : ''}
                                    </Box>
                                </Box>
                                {this.props.workload.UserInputs.Environments.WorkloadType !== 'BigData' ?
                                    <Box size="xlarge" separator="all" pad='none' margin='none' style={{ width: '95%', marginTop: '5px' }}>
                                        <Box align='start' wrap={true} size="xlarge" pad='none' margin='none' style={{ width: '95%', paddingLeft: "10px", marginTop: '5px' }}>
                                            {/* <Heading tag='h6' strong={true} style={{ marginLeft: '10px', marginTop: '5px' }}>Data fabric</Heading> */}
                                            {/* <Heading tag='h6' strong={true} style={{ marginLeft: '5px', marginTop: '5px' }}>Data Fabric</Heading> */}
                                            <Box pad={{ between: 'small' }} style={{ marginBottom: '10px', display: '', width: '100%' }}>
                                                <Box direction='row' align='start' pad={{ between: 'small' }} style={{ width: '90%', marginLeft: '4.5%' }}>
                                                    {/*<FormField className="DiskCapacityDetails"></FormField>*/}
                                                    {/*<CheckBox label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>HPE Runtime Enterprise</Paragraph>
                                                    <CircleInformation data-tip={CLEraEssTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.KubernetesHPECPChBox} onChange={() => this.onKubernetesChBoxsChange("HPECP")} style={{ overflow: "hidden", width: '62%' }} />*/}
                                                    {/*<Box direction='row' style={{ height: '38px',padding:'10px 25px' }}>
                                                        <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>HPE Runtime Enterprise</Paragraph>
                                                        <CircleInformation data-tip={CLEraEssTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                    </Box>
                                                    <Select placeHolder='None' value={KubernetesHPECPValue} options={KubernetesHPECPOptions} onChange={(e) => { this.onKubernetesvalueChanges(e, 'HPECP') }} />
                                                </FormField>*/}
                                                    <FormField className="DiskCapacityDetails"><CheckBox label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.RE}</Paragraph>
                                                        {/* <CircleInformation  data-tip={CLEraEntDataHubTooltip}  colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /> */}</Box>} checked={this.state.KubernetesDataappsChBox} onChange={() => this.onKubernetesChBoxsChange("Data Apps")} style={{ overflow: "hidden", width: '62%' }} />
                                                        <Select placeHolder='None' value={this.state.KubernetesDataappsChBox ? KubernetesDataAppsValue : 'None'} options={this.state.KubernetesDataappsChBox ? KubernetesDataAppsOptions.filter(item => item !== 'None') : ['None']} onChange={(e) => { this.onKubernetesvalueChanges(e, 'Data Apps') }} />
                                                    </FormField>
                                                    {/*  Commented by aditya, discussed with bharat  <FormField className="DiskCapacityDetails"><CheckBox label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Data Apps Universal</Paragraph>
                                                        <CircleInformation data-tip={CLEraDataSciNdEngTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.KubernetesDataappsUniversalChBox} onChange={() => this.onKubernetesChBoxsChange("Data Apps Universal")} style={{ overflow: "hidden", width: '62%' }} />
                                                        <Select placeHolder='None' value={KubernetesDataAppsUniversalValue} options={KubernetesDataAppsUniversalOptions} onChange={(e) => { this.onKubernetesvalueChanges(e, 'Data Apps Universal') }} />
                                                    </FormField> */}
                                                    <FormField className="DiskCapacityDetails"><CheckBox label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>ML Ops</Paragraph>
                                                    </Box>} checked={this.state.KubernetesDataappswMLOpsChBox} onChange={() => this.onKubernetesChBoxsChange("Data Apps w/ML Ops")} style={{ overflow: "hidden", width: '62%' }} />
                                                        <Select placeHolder='None' value={this.state.KubernetesDataappswMLOpsChBox ? KubernetesDataAppswMLOpsValue : 'None'} options={this.state.KubernetesDataappswMLOpsChBox ? KubernetesDataAppswMLOpsOptions.filter(item => item !== 'None') : ['None']} onChange={(e) => { this.onKubernetesvalueChanges(e, 'Data Apps w/ML Ops') }} />
                                                    </FormField>
                                                </Box>
                                                {/* Commented by aditya, discussed with bharat <Box direction='row' pad={{ between: 'small' }} style={{ width: '90%', marginLeft: '4.5%' }}>
                                                    <FormField className="DiskCapacityDetails" style={{ width: '37.5%' }}><CheckBox label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Data Apps Universal w/ML Ops Select</Paragraph>
                                                        <CircleInformation data-tip={CLEraAnalDBTooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.KubernetesDataappsUniversalwMLOpsChBox} onChange={() => this.onKubernetesChBoxsChange("Data Apps Universal w/ML Ops")} style={{ overflow: "hidden", width: '62%' }} />
                                                        <Select placeHolder='None' value={KubernetesDataAppsUniversalwMLOpsValue} options={KubernetesDataAppsUniversalwMLOpsOptions} onChange={(e) => { this.onKubernetesvalueChanges(e, 'Data Apps Universal w/ML Ops') }} />
                                                    </FormField>
                                                </Box> */}
                                            </Box>
                                        </Box>
                                    </Box> : ''}


                                {/*Software Licenses*/}
                                {overallConfigType === Constants.KUBERNETES_ || this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA ?
                                    <Box size="xlarge" separator="all" pad='none' margin='none' style={{ width: '95%', marginTop: '5px', paddingLeft: "10px" }}>
                                        <Heading tag='h6' strong={true} style={{ marginLeft: '10px', marginTop: '5px' }}>Ezmeral {Constants.RE} Additional Services</Heading>
                                        <Box direction="row" align='start' wrap={false} pad={{ between: 'small' }} margin='medium' style={{ marginTop: '10px', flexWrap: "wrap", width: '100%', marginLeft: '4.5%' }}>
                                            {this.props.workload.UserInputs.Environments.WorkloadType === 'BigData' ?
                                                <FormField style={{ width: '29%', marginBottom: '10px' }} ><RadioButton disabled={BlueDataEpicDisabled} id='BlueEPIC' label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.HPE_E_CP} EPIC Software </Paragraph> <CircleInformation data-tip={'A HPE Ezmeral ' + Constants.RE + ' license is required. Select the term of the support desired.'} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.BlueDataEpicChecked} onChange={this.onBlueDataRadioBtnChange} style={{ overflow: "hidden", width: '62%' }} />
                                                    <Select placeHolder='None' value={BluedataEpicsftwreValue} options={BluedataEpicsftwreOptions} onChange={(e) => this.OnBlueDataChange(e, "BlueData EPIC Software")} />
                                                </FormField > : ''}
                                            {this.props.workload.UserInputs.Environments.WorkloadType === 'BigData' ?
                                                <FormField style={{ width: '29%', marginBottom: '10px' }} ><RadioButton disabled={BlueDataMLDisabled} id='BlueML' label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>HPE Ezmeral ML Ops Software </Paragraph> <CircleInformation data-tip={'A HPE Ezmeral ' + Constants.RE + ' ML license is required. Select the term of the support desired.'} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} checked={this.state.BlueDataMLChecked} onChange={this.onBlueDataRadioBtnChange} style={{ overflow: "hidden", width: '62%' }} />
                                                    <Select placeHolder='None' value={BluedataMLsftwreValue} options={BluedataMLsftwreOptions} onChange={(e) => this.OnBlueDataChange(e, Constants.HPE_EZMERAL_MLOPS)} />
                                                </FormField > :
                                                <FormField style={{ width: '42%', marginBottom: '10px' }} label={
                                                    <Box direction='row' style={{ height: '25px' }}>
                                                        <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>HPE {Constants.RE_SHORT} External Kubernetes Cluster Manager </Paragraph>
                                                        <CircleInformation data-tip={'A HPE Ezmeral ' + Constants.RE + ' ML license is required. Select the term of the support desired.'} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                    </Box>}>
                                                    <Select placeHolder='None' value={kubernetesCM} options={externalK8sClusterMngrOptions} onChange={(e) => this.OnBlueDataChange(e, Constants.HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR)} />
                                                </FormField >}
                                        </Box>
                                    </Box> : ''}
                                {VMWareLicenses}
                                <Box size="xlarge" separator="all" pad='none' margin='none' style={{ width: '95%', marginTop: '5px' }}>
                                    <Heading tag='h6' strong={true} style={{ marginLeft: '10px', marginTop: '5px' }}>Other Licenses</Heading>
                                    <Box direction="row" align='start' wrap={false} pad={{ between: 'small' }} margin='medium' style={{ marginTop: '10px', flexWrap: "wrap", width: '100%', marginLeft: '4.5%' }}   >
                                        <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Scality</Paragraph>
                                            <CircleInformation data-tip='Scality RING licenses' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ marginBottom: '5px', display: scalitydisplay, width: '320px' }}>
                                            <Select placeHolder='None' value={this.props.workload.UserInputs.Environments.HadoopServices['Scality']} options={this.state.ScalityOptions} onChange={(e) => this.OnLicenseChange(e, "Scality")} />
                                        </FormField>
                                        <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>HPCM/CMU License</Paragraph>
                                            <CircleInformation data-tip='HPCM: HPE Performance Cluster Manager provides complete provisioning, management and monitoring for clusters scaling to 100,000 nodes.  CMU: HPE Insight CMU is an integrated, easy-to-use tool for cluster administration, providing complete provisioning, management and monitoring for clusters of any scale.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ marginBottom: '5px', width: '320px' }}>
                                            <Select placeHolder='None' value={this.props.workload.UserInputs.Environments.HadoopServices['HPCM']} options={this.state.HPCMOptions} onChange={(e) => this.OnLicenseChange(e, "HPCM")} />
                                        </FormField>
                                        <FormField className="HWSupport" label='Linux License' style={{ marginBottom: '5px', width: "320px" }}>
                                            <Select placeHolder='None' value={this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']} options={this.state.LinuxLicenseOptions} onChange={(e) => this.OnLicenseChange(e, "LinuxLicense")} />
                                        </FormField>
                                        <FormField className="HWSupport" style={{ marginBottom: '5px', width: "320px" }} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>iLO License</Paragraph>
                                            <CircleInformation data-tip='iLO: HPE Integrated Lights-Out (iLO) provides the automated intelligence to maintain complete server control from any place, anywhere and ships with every ProLiant Server. Purchasing 1 or 3 year support licenses refers to the length of the support agreement for licensed iLO features."' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select placeHolder='None' value={this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']} options={this.state.iLOLicenseOptions} onChange={(e) => this.OnLicenseChange(e, "iLoLicense")} />
                                        </FormField>
                                    </Box>
                                </Box>
                                <Box size="xlarge" separator="all" pad='none' margin='none' style={{ width: '95%', marginTop: '5px' }}>
                                    <Box align='start' wrap={false} pad={{ between: 'small' }} margin='medium' style={{ marginTop: '27px', marginLeft: '6px', width: '100%' }}  >
                                        <Heading tag='h6' strong={true} style={{ marginLeft: '10px', marginTop: '5px', marginBottom: '0px' }}> HPE Ezmeral {Constants.RE} Additional Services</Heading>
                                        <Box direction="row" pad={{ 'between': 'small' }} style={{ marginLeft: '4.5%', width: '95%' }}>
                                            <Box pad={{ 'between': 'small' }} style={{ width: '53%' }} >
                                                <Box pad={{ 'between': 'small' }} >
                                                    <CheckBox className='LatestLicenses' disabled={AddservicesInstallDissable} label="Installation and Start-up Services" checked={this.state.InstallationCheckbox} onChange={(e) => this.onLicensesChanged(e, "Installation")} style={{ overflow: "hidden" }} />
                                                </Box>
                                                <Box direction="row" pad={{ 'between': 'small' }} >
                                                    <CheckBox className='LatestLicenses' disabled={AddservicesDissable} label={Constants.HPE_E_CP + " Single Image Development SVC"} checked={this.state.SingleImageCheckbox} onChange={(e) => this.onLicensesChanged(e, "SingleImage")} style={{ overflow: "hidden" }} />
                                                    <Box direction="row" alignContent='center' align='center' >
                                                        <TextInput id='UserDefined' value={SingleQtyVal} hidden={!this.state.SingleImageCheckbox} style={{ width: '40%', border: '1px solid #01a982' }} onDOMChange={(e) => this.onLicensesQtyChanged(e, "SingleImage", "Change")} onBlur={(e) => this.onLicensesQtyChanged(e, "SingleImage", "Blur")} />
                                                        <Paragraph className='DesignrequirementsPara' hidden={!this.state.SingleImageCheckbox} style={{ marginLeft: "7px" }}>{"Qty"}</Paragraph>
                                                    </Box>
                                                </Box>
                                                <Box direction="row" pad={{ 'between': 'small' }} >
                                                    <CheckBox className='LatestLicenses' disabled={AddservicesDissable} label={Constants.HPE_E_CP + " Custom Image Development SVC"} checked={this.state.EPICCustomCheckbox} onChange={(e) => this.onLicensesChanged(e, "CustomImage")} style={{ overflow: "hidden" }} />
                                                    <Box direction="row" alignContent='center' align='center' >
                                                        <TextInput id='UserDefined' value={CustomQtyVal} hidden={!this.state.EPICCustomCheckbox} style={{ width: '40%', border: '1px solid #01a982' }} onDOMChange={(e) => this.onLicensesQtyChanged(e, "CustomImage", "Change")} onBlur={(e) => this.onLicensesQtyChanged(e, "CustomImage", "Blur")} />
                                                        <Paragraph className='DesignrequirementsPara' hidden={!this.state.EPICCustomCheckbox} style={{ marginLeft: "7px" }}>{"Qty"}</Paragraph>
                                                    </Box>
                                                </Box>

                                                <Box pad={{ 'between': 'small' }} >
                                                    <CheckBox className='LatestLicenses' disabled={true} label={Constants.HPE_E_CP + " App Store Development SVC"} checked={this.state.AppStoreCheckbox} onChange={(e) => this.onLicensesChanged(e, "AppStore")} style={{ overflow: "hidden" }} />
                                                </Box>
                                            </Box>
                                            <Box pad={{ 'between': 'small' }} >
                                                <Box pad={{ 'between': 'small' }} >
                                                    <CheckBox className='LatestLicenses' disabled={AddservicesDissable} label={Constants.HPE_E_CP + " Deployment and Integration Services"} checked={this.state.DeploymentCheckbox} onChange={(e) => this.onLicensesChanged(e, "Deployment")} style={{ overflow: "hidden", }} />
                                                    {ExtraServices}
                                                </Box>

                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box justify='start' margin="none" pad="none" style={{ paddingTop: '12px', width: '95%' }}>
                                    <Box style={{ borderBottom: '1px solid gray' }} margin='none' pad='none'><Heading style={{ marginBottom: '5px' }} tag='h4' strong={true} >Support</Heading></Box>
                                </Box>
                                <Box direction="row" align='start' pad={{ between: 'small' }} margin='small' style={{ width: '92%', marginBottom: '16%', marginTop: '10px', marginLeft: '5%' }} >
                                    <FormField className="HWSupport" label='HW Support' style={{ marginBottom: '5px', width: '33%' }}>
                                        <Select placeHolder='None' value={this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']} options={this.state.HWSupportOptions} onChange={(e) => this.OnLicenseChange(e, "HWSupport")} />
                                    </FormField>
                                </Box>
                            </Box>
                        </Box>

                    </Article>
                </Box>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {

        workload: state.sizerWorkload.workload,
        activeSession: state.sessions.activeSession,
        ServicesInput: state.sizerWorkload,
        services: state.sessions,
        ConfigButton: state.sizerWorkload.calbtn,
        GPUdetails: state.sizerWorkload.GPUdetails,
        NonGPUdetails: state.sizerWorkload.NonGPUdetails,
        GPUdetailsforcore: state.sizerWorkload.workload.UserInputs.Environments,
        displayWarning: state.sizerWorkload.guiState.displayWarning
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) },
        updateError: (errorMsg) => {
            dispatch(errorValidataion(errorMsg));
        },
        OntoggleSizeButton: (value) => {
            dispatch(toggleSizeButton(value));
        },
        //    OnFetchDefaults:()=>{
        //     dispatch(fetchDefaults());
        //   }
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(HadoopServices);




// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/HadoopServices.js